import React, { useState, useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { FiChevronLeft } from "react-icons/fi";
import { FiChevronRight } from "react-icons/fi";
import {v4 as uuidv4} from 'uuid'

export default function Carousel() {

    const initialImgArray = [
        {
            id: 1,
            name: "Colas Nord Est",
            current: "show",
            src: "https://www.mife90.org/emplitude/img/logo/Logo_Colas.png",
            legend: "(Travaux publics) Labellisé le 12 juillet 2018, renouvelé le 12 avril 2022"
        },
        {
            id: 2,
            name: "Serge Morel",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/serge_morel.png",
            legend: "(Charpente – Couverture – Zinguerie) Labellisé le 5 novembre 2018, renouvelé le 9 juin 2022",
        },
        {
            id: 3,
            name: "Roger Martin ",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/roger_martin.png",
            legend: "(Travaux Publics) Labellisé le 5 novembre 2018, renouvelé le 22 novembre 2021",
        },
        {
            id: 4,
            name: "Albizzati Père et Fils",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/albizzati.png",
            legend: "(Travaux de maçonnerie générale et gros œuvre de bâtiment) Labellisé le lundi 28 janvier 2019, renouvelé le 15 septembre 2022",
        },
        {
            id: 5,
            name: "Groupe NEGRO Père et Fils",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/negro_pere_fils.png",
            legend: "(Menuiserie générale) Labellisé le 28 janvier 2019, renouvelé le 18 octobre 2022",
        },
        {
            id: 6,
            name: "SAS Kalbe",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/sas_kalbe.png",
            legend: " (Transports par benne, travaux publics) Labellisé le 12 mars 2019, renouvelé le 14 septembre 2023",
        },
        {
            id: 7,
            name: "Toitures Morel",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/toiture_morel.png",
            legend: "(Charpente – couverture – zinguerie) Labellisé le 28 mars 2019, renouvelé le 8 novembre 2022",
        },
        {
            id: 8,
            name: "Menuiserie Claude",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/menuiserie_claude.png",
            legend: "(Travaux de menuiserie bois et PVC) Labellisé le 3 juin 2019, renouvelé le 23 février 2023",
        },
        {
            id: 9,
            name: "Bardoz",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/bardoz.png",
            legend: "Bâtiments & Travaux-Publics (Maçonnerie générale, travaux publics) Labellisé le 6 juin 2019, renouvelé le 8 juin 2023",
        },
        {
            id: 10,
            name: "Cabete Façades",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/cabete.png",
            legend: "(Travaux de façade) Labellisé le 2 juillet 2019",
        },
        {
            id: 11,
            name: "Chauvier",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/chauvier_sas.png",
            legend: "(Travaux de revêtement des sols et des murs) Labellisé le 8 juillet 2019, renouvelé le 13 décembre 2023",
        },
        {
            id: 12,
            name: "Francis TP",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/francis_tp.png",
            legend: "(assainissement, TP) Labellisé le 4 novembre 2019, renouvelé le 13 décembre 2022",
        },
        {
            id: 13,
            name: "Amaelles ",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/amaelles.png",
            legend: "Territoire de Belfort (Aide à domicile) Labellisé le 14 novembre 2019, renouvelé le 13 décembre 2022",
        },
        {
            id: 14,
            name: "ID Verde",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/idverde.png",
            legend: "(Espaces verts et construction de terrains de sport) Labellisé le 9 décembre 2019",
        },
        {
            id: 15,
            name: "SARL Houzé",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/houze.png",
            legend: "(charpente, couverture, zinguerie) Labellisé le 9 septembre 2020",
        },
        {
            id: 16,
            name: "ESDI Groupe",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/esdi.jpg",
            legend: "(Externalisation de la gestion des systèmes d’information et de la relation client) Labellisé le 22 novembre 2021",
        },
        {
            id: 17,
            name: "Automobiles Subasi",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/subasi.png",
            legend: "(carrosserie, réparation et vente automobile) Labellisé le 12 avril 2022",
        },
        {
            id: 18,
            name: "SAS Curti",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/curti.jpg",
            legend: "(plâtrerie - peinture) Labellisé le 9 juin 2022",
        },
        {
            id: 19,
            name: "SIVM Venini sol décor",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/Logo_VENINI.webp",
            legend: "(second oeuvre du bâtiment, rénovation intérieure) Labellisé le 15 septembre 2022",
        },
        {
            id: 20,
            name: "Azaé",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/azae.jpg",
            legend: "(aide à la personne) Labellisé le 18 octobre 2022",
        },
        {
            id: 21,
            name: "Auchan",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/auchan.png",
            legend: "(grande distribution) Labellisé le 8 novembre 2022",
        },
        {
            id: 22,
            name: "MDTE",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/mdte.jpg",
            legend: "(chauffage et climatisation) Labellisé le 23 février 2023",
        },
        {
            id: 23,
            name: "LK EUROCAR HORN / LK Aire urbaine",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/lk.png",
            legend: "(transport de voyageurs) Labellisé le 8 juin 2023",
        },
        {
            id: 24,
            name: "ENGIE Solutions Belfort",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/engie.png",
            legend: "(production de chaleur) Labellisé le 14 septembre 2023",
        },
        {
            id: 25,
            name: "EUROVIA Belfort-Montbéliard",
            current: "hide",
            src: "https://www.mife90.org/emplitude/img/logo/eurovia.jpg",
            legend: "(travaux publics) Labellisé le 13 décembre 2023",
        },
       
    ]
    
    const [imgArray, setImgArray] = useState(initialImgArray)

    
    const [dotArray, setDotArray] = useState([{
        id: 1,
        name: "Colas Nord Est",
        current: "show",
        src: "https://www.mife90.org/emplitude/img/logo/Logo_Colas.png",
        legend: "(Travaux publics) le 12 juillet 2018, renouvelé le 12 avril 2022"
    },
    {
        id: 2,
        name: "Serge Morel",
        current: "hide",
        src: "https://www.mife90.org/emplitude/img/logo/serge_morel.png",
        legend: "(Charpente – Couverture – Zinguerie) le 5 novembre 2018, renouvelé le 9 juin 2022",
    },
    {
        id: 3,
        name: "Roger Martin ",
        current: "hide",
        src: "https://www.mife90.org/emplitude/img/logo/roger_martin.png",
        legend: "(Travaux Publics) le 5 novembre 2018, renouvelé le 22 novembre 2021",
    }])    

    console.log(dotArray);
   
    const tmpImgArray = [...imgArray]


    var numSlides = imgArray.length;
    let count = useRef(1);

   
    const dotChange = (id) => {
        count.current = id
        console.log(count.current);
        console.log(id);

        const newState = imgArray.map(img => {
            if(img.id === id) {
                console.log(img);
                return {...img, current: "show"}
            }
            if(img.id != id) {
                return {...img, current: "hide"}
            }  
            
            return img;

        })

       setImgArray(newState)
    }

    useEffect(() => {
       const autoplay = setInterval(() => {
         handleNext()
       }, 5000);
       return () => clearInterval(autoplay);
    }, []);
 
    const updateImgArray = async () => {
      
        const newState = imgArray.map(img => {
            if(img.id === count.current) {
                console.log(img);
                return {...img, current: "show"}
            }
            if(img.id != count.current) {
                return {...img, current: "hide"}
            }  
            
            return img;
        })
        setImgArray(newState)
      
 
        let ctx = gsap.context(() => {
            gsap.to('#img', {
                opacity: 0,
                ease: "Power2.easeInOut",
                duration: 2,
                delay: 1.2
            })
            gsap.to('.show', {
                opacity: 1,
                ease: "Power2.easeInOut",
                duration: 2,
                delay: 1.2
            })
        })
        console.log(imgArray);
    }


    const handlePrevious = async () => {
        
        count.current++
        imgArray.forEach((slide, i) => {
            let ctx = gsap.context(() => {
                gsap.set('.show', {
                    left: 0,
                    duration: 0.2,
                })
                gsap.set('.hide', {
                    left: 25,
                    duration: 0.2,
                })
            })
        })
        
        if(count.current > numSlides) {
               
                count.current = 1
            }    
            updateImgArray()
            console.log(count.current);
    }

    const handleNext = async () => {
    
        count.current--
        if(count.current  <= 0) {
            count.current = numSlides
        }
        updateImgArray()
        console.log(count.current);
    }


  return (
    <div>
        <div className="carousel_container">
            <div className="img_box">
                <div className="img_container">
                  {imgArray.map(img=> {
                    return <div className={img.current} key={uuidv4()} id='label'><div className="img_wrapper"><img src={img.src} alt="" /></div> <h3>{img.name}</h3> <p>{img.legend}</p></div>
                  })}
                </div>
            </div>
            <div className="controllers">
                <div className="left" onClick={handlePrevious}>
                  <FiChevronLeft  />
                </div>
                <div className="right" onClick={handleNext}>
                  <FiChevronRight />
                </div>
            </div>
            {/* <div className="picsNumber">
                {imgArray.map(img=> {
                    return <div className={img.current + '_dot'} onClick={() => dotChange(img.id)} key={uuidv4()} id='dot'></div>
                  })}
            </div> */}
          
        </div>
    </div>
  )
}
